export default {
    "label.update_translations_unsuccessful": "",
    "global.no_records": "Nicio înregistrare",
    "notifications.rp_has_been_updated": "Proiectul Rezidențial a fost actualizat",
    "moduleTitle.files": "Fișiere",
    "label.coordinator": "Coordonator",
    "sidebar.translations_managment": "",
    "table.file": "Fișier",
    "label.report_overview": "",
    "label.parent_agreement": "Acordul părintelui",
    "parentalConsent.i_consent_to_and_understand_that": "6. Sunt de acord și înțeleg că participantului i se pot face fotografii în cadrul diferitelor activități legate de Award și ca aceste fotografii pot fi folosite în scopuri promoționale, cu condiția semnării unui formular de autorizație de publicare atât de părinte/tutore, cât și de participant. ",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. Înțeleg că participanții trebuie să urmeze cerințele programului Award așa cum sunt descrise în Carnetul de Progres sau ORB, politicile și standardele comportamentale ale Operatorului Award (cu amendamentele periodice) și cerințele Unității Award cu privire la procedurile de urgență, evaluarea activităților și conduita pe toată durata secțiunii de Aventură, și înțeleg că Unitatea Award poate retrage aprobarea participării participantului în Award dacă acesta nu se conformează cerințelor.",
    "table.end_date": "Data de finalizare",
    "label.activation_date": "Data activării",
    "label.report": "",
    "label.award_is_offline": "",
    "label.pending_changes": "Schimbări în așteptare...",
    "errors.min_nights_required": "Este necesar un minim de {nights} noapte/nopți",
    "label.country": "Țara",
    "notifications.award_leader_has_been_returned": "Liderul Award a fost revizuit",
    "notifications.participant_has_been_updated": "Participantul a fost actualizat",
    "label.phone_number": "Număr telefon",
    "roles.aj_assessor": "Evaluator Aventură",
    "notifications.person_state_has_been_changed": "Starea persoanei a fost modificată",
    "pageTitle.dashboard": "Bord",
    "moduleTitle.global_payment_method": "Metoda globală de plată",
    "label.organization_type": "Tipul organizației",
    "button.account_settings": "Setări cont",
    "notifications.contact_has_been_updated": "Contactul a fost actualizat",
    "participant.recover_password": "Recuperare parolă",
    "notifications.assessment_request_has_been_sent": "Cererea de evaluare a fost trimisă",
    "button.unassign": "",
    "label.start_date": "Data începerii",
    "label.assign_labels": "",
    "sidebar.participants": "Participanți",
    "roles.coordinator": "Coordonator",
    "label.organization_contact": "Contact organizație",
    "tabs.customization": "Personalizare",
    "sidebar.award_units": "Unități Award",
    "button.change_goal": "Schimbă scop",
    "translationsManagement.selectProject": "",
    "award.rp": "Proiect Rezidențial",
    "label.size": "",
    "label.bulk_action_results": "",
    "notifications.activity_has_been_approved": "Activitatea a fost aprobată",
    "label.payment_type": "",
    "button.gop_assignment": "",
    "button.resend_assessment_request": "Retrimite cererea de evaluare",
    "notifications.template_has_been_removed": "Șablonul a fost ăndepărtat",
    "button.award_settings": "Setări Award",
    "pageTitle.payment": "Plată",
    "tasks.return_award": "Revizuiește program Award",
    "label.link": "link",
    "moduleTitle.award_participant_delete": "",
    "pageTitle.mro_related_contacts": "Biroul meu Regional - Contacte conexe",
    "pageTitle.my_organization_labels": "",
    "tabs.activity_signoff": "Aprobare secțiune",
    "table.logs": "Note de jurnal",
    "moduleTitle.remove_file": "Șterge fișier?",
    "label.email_confirmed": "Email confirmat",
    "notifications.activity_has_been_returned": "Activitatea a fost revizuită",
    "label.note": "Mesaj",
    "button.show": "",
    "tabs.adventurous_journey": "Aventură",
    "sidebar.my_todolist": "",
    "label.here": "",
    "organisation.change_award_mode": "",
    "table.note_from_al": "Mesaj de la Liderul Award",
    "label.gender": "Sex",
    "moduleTitle.remove": "Șterge?",
    "errors.must_be_less_than": "Trebuie să fie mai mic decât {limit}",
    "button.logout": "Deconectare",
    "label.no_selected_participants": "Niciun participant selectat",
    "button.new_aj_event": "Un eveniment nou pentru călătoria de aventură",
    "label.employement_status": "Statutul de angajat",
    "tabs.logs": "Note de jurnal",
    "tabs.contacts": "Contacte",
    "label.option": "Opțiune",
    "dashboard.charts": "Diagrame",
    "notifications.rp_has_been_approved": "Proiectul Rezidențial a fost aprobat",
    "pageTitle.new_participant": "Participant nou",
    "notifications.award_leader_has_been_approved": "Liderul Award a fost aprobat",
    "moduleTitle.would_you_like_to_remove_leader_training": "Doriți să ștergeți formarea Liderului Award?",
    "moduleTitle.update_configuration_value": "Valoarea configurației de actualizare",
    "table.description": "Descriere",
    "table.organization": "Organizație",
    "label.youtube": "YouTube",
    "label.author": "Autor",
    "table.suitable_for_award_level": "Potrivit pentru nivelul Award",
    "label.content_update": "Vă rugăm așteptați. Actualizăm conținutul...",
    "notifications.new_question_has_been_added": "A fost adăugată o întrebare nouă",
    "pageTitle.nao_awards": "Biroul Național - Programe Award",
    "table.last_name": "Nume de familie",
    "moduleTitle.adventurous_journey_detail": "",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": ""},
    "label.project_location_type": "Tipul locației Proiectului",
    "label.email_help_award_level": "",
    "label.date": "Data",
    "label.previous_completed_award_place": "Unde",
    "button.show_more": "Arată mai mult",
    "label.wwc_number": "WWC number",
    "button.filter": "Filtrează",
    "notifications.rp_has_been_returned": "Proiectul Rezidențial a fost revizuit",
    "pageTitle.residetial_project_assessor_report": "Proiect Rezidențial - Raportul Evaluatorului",
    "label.generating": "",
    "moduleTitle.finance_system_data": "",
    "notifications.adventurous_journey_state_has_been_changed": "Starea Aventurii a fost schimbată",
    "route.levels": "Niveluri",
    "moduleTitle.activity_leader": "Liderul activității",
    "tasks.approve_event": "Aprobă eveniment",
    "tasks.reject_event": "Revizuiește eveniment",
    "table.region": "Regiune",
    "pageTitle.nao_award_leaders": "Birou Național - Lideri Award",
    "errors.must_be_at_least": "Trebuie să fie de cel puțin {min} caractere",
    "table.title": "Titlu",
    "table.last_activity": "Ultima activitate",
    "tasks.delete_registration": "Șterge înregistrarea",
    "table.date_time": "",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. Operatorii Award îți vor respecta intimitatea. Informațiile personale sunt necesare în acest formular doar pentru a putea participa în Award. Participanții care nu ne oferă aceste informații nu pot participa în program (acest lucru nu se aplică în cazul neasigurării datelor participantului). Putem folosi informațiile tale personale pentru a-ți trimite informații despre activități sau evenimente Award care considerăm că te pot interesa. Putem divulga aceste informații altor organizații locale sau internaționale și furnizorilor de servicii care ne ajută în operarea și administrarea programului Award. Dacă dorești să ne contactezi sau să accesezi datele tale personale, te rugăm să-i scrii Operatorului Award. Poți contacta Opertorul Award pentru a cere o copie a Politicii de Confidențialitate.",
    "aj.practice_journey": "Călătorie de antrenament",
    "notification.log_has_been_restored": "",
    "tabs.my_participants": "Participanții mei",
    "label.bulk_action_assign_label": "",
    "moduleTitle.supervisor": "Supraveghetor",
    "moduleTitle.your_parental_consent": "Acordul părintelui",
    "route.registration_participants": "Înregistrare participanți",
    "placeholder.start_typing": "Scrie...",
    "tasks.approve_award": "Aprobă program Award",
    "route.registrations": "Înregistrări",
    "button.add_activity": "",
    "notifications.aj_event_has_been_created": "Eveniment Aventură creat",
    "states.supervisor_approval": "Aprobare Evaluator",
    "label.description": "Descriere",
    "button.leave_anyway": "Renunță",
    "tabs.registrations": "Înregistrări",
    "states.leader_signoff": "",
    "moduleTitle.forbidden": "",
    "notifications.translations_has_been_updated.button": "",
    "pageTitle.nao_registration": "Birou Național - Înregistrare",
    "pageTitle.mro_logs": "Birourile mele regionale - Note de jurnal",
    "meta.page_not_found": "Pagina nu a fost găsită",
    "label.bulk_action_unsuccessful": "",
    "global.days": "zile",
    "table.review": "Revizuire",
    "table.as_assessor_for": "Ca Evaluator pentru",
    "roles.if_staff_statistical_user": "Utilizator statistic IF",
    "table.levels": "Niveluri",
    "label.suitable_for_level": "Potrivit pentru nivel",
    "pageTitle.leaders": "Lideri",
    "moduleTitle.send_test_email": "Trimite e-mail de test",
    "pageTitle.tasks_removed_registration": "",
    "label.you_will_be_forced_to_login_again_after_change": "",
    "table.recent_updates": "",
    "pageTitle.tasks_activity_signoffs": "Aprobare Secțiune",
    "pageTitle.payments": "Plăți",
    "global.nights": "nopți",
    "label.blank_any_level": "",
    "button.view_section": "",
    "moduleTitle.select_organization": "Selectează organizația",
    "pageTitle.manual_data_import": "",
    "button.upload_files": "Încarcă fișiere",
    "label.migrated_contact_email": "Email contact transferat",
    "label.for_award_unit": "Pentru Unitatea Award",
    "label.aj_template_note": "Mesaj șablon",
    "table.last_log_added": "",
    "button.view_participant": "",
    "label.please_comment_on_the_participants": "Vă rugăm comentați implicarea/performanța/îmbunătățirea activității participanților",
    "label.consent_already_given_login": "Consimțământul a fost deja dat. Vă rugăm să vă autentificați cu contul copilului dvs.",
    "participant.level_start_date": "Data de început a {value}",
    "sidebar.my_region_office": "Biroul meu regional",
    "states.section_signoff": "Aprobare Secțiune",
    "moduleTitle.assessor_details": "Detalii Evaluator",
    "moduleTitle.adventurous_journey_settings": "Setări Aventură",
    "moduleTitle.note_from_al": "Mesaj de la Liderul Award",
    "button.add_role": "Adaugă rol",
    "table.run": "Execută",
    "states.change_to_state_warning_missing_assessment": "",
    "label.user_app_guide_leader": "Ghid utilizator app - Lider Award",
    "tabs.section_approval": "Aprobare secțiune",
    "roles.award_verifier": "Verificator Award",
    "tabs.activity_approval": "Aprobare activitate",
    "logs.add_log": "Adaugă notă de jurnal",
    "tabs.award": "Award",
    "notifications.this_role_has_read_only_persmission": "",
    "table.no_filtered_results": "Nu sunt rezultate filtrate",
    "button.praise": "",
    "label.prevent_welcome_email_assessor": "",
    "label.location_detail": "Detalii locație",
    "label.optional": "(opțional)",
    "errors.do_not_match": "Nu se potrivesc",
    "label.use_comma_for_multiple_entries": "",
    "label.operating_authority": "Autoritate Operațională",
    "label.activity_section": "Secțiunea de activitate",
    "notifications.you_have_been_logged_out": "Ați fost deconectat",
    "table.finished": "Finalizat",
    "button.same_as_billing": "La fel ca Factura",
    "table.payment": "Plată",
    "table.current_level": "Nivel actual",
    "button.view_nao": "",
    "table.email_confirmation": "Confirmare email",
    "moduleTitle.shipping_address": "Adresa de livrare",
    "label.secondary_phone_type": "Tipul telefonului secundar",
    "notifications.saved": "Salvat",
    "pageTitle.all_participants": "Toți participanții",
    "label.first_name": "Prenume",
    "label.oa_price": "Prețul pentru AO",
    "table.award_mode": "",
    "tabs.api_keys": "",
    "award.award_detail": "Detalii program Award",
    "tabs.user_management": "Administrare Utilizator",
    "tabs.all_events": "Toate evenimentele",
    "notifications.history_record_has_been_removed": "Înregistrarea din istorie a fost ștearsă",
    "award.no_data": "Nu sunt date",
    "notifications.preparation_training_has_been_added": "Pregătirea și instruirea au fost adăugate",
    "label.message": "Mesaj",
    "notifications.participant_info_updated": "",
    "roles.nao_staff": "Personal ANA",
    "tabs.adventurous_journeys": "Călătorii de aventură",
    "label.gops": "",
    "route.upload": "Încarcă",
    "notifications.history_record_has_been_added": "Înregistrarea din istorie a fost adăugată",
    "notifications.history_record_has_been_updated": "Înregistrarea din istorie a fost actualizată",
    "label.no_data": "Nu sunt date",
    "button.add_coordinator": "Adaugă coordonator",
    "label.you_are_already_logged_as": "Ești deja autentificat ca ",
    "route.my_national_office": "Biroul meu Național",
    "tabs.leaders": "Lideri",
    "label.email_confirmation": "Confirmare email",
    "table.registration_date": "Data înregistrării",
    "notifications.role_has_been_removed": "Rolul a fost șters",
    "button.move": "",
    "label.terms_and_conditions": "",
    "pageTitle.detail": "Detalii",
    "table.award_unit": "Unitate Award",
    "sidebar.settings": "Setări",
    "dashboard.leader_state": "Lideri - după Țară",
    "notifications.award_unit_has_been_approved": "Liderul Award a fost aprobat",
    "states.awaiting_approval": "Aprobare în așteptare",
    "table.level": "Nivel",
    "table.action_requested": "",
    "label.organisation_mode": "",
    "label.no_note": "Nici un mesaj",
    "tabs.my_events": "Evenimentele mele",
    "notifications.participants_have_been_added": "Participanții au fost adăugați",
    "tabs.registration_questions": "",
    "button.delete_registration": "Șterge înregistrarea",
    "notifications.parental_consent_link_has_been_sent": "Link cu acordul părintelui a fost retrimis",
    "moduleTitle.select_role_organization": "Selectează rolul și organizația",
    "label.experience": "Experiență",
    "translationsManagement.modal.title": "",
    "table.ic": "Țară Independentă",
    "table.id": "ID",
    "label.notify_email_explanation": "",
    "participant.would_you_like_to_remove": "Ați vrea să ștergeți acest cont?",
    "table.fields_included": "",
    "label.user_guide_web_leader": "Ghid utilizator web - Lider Award",
    "label.journey_type": "Tipul călătoriei",
    "button.setup": "Setează",
    "tabs.my_national_office": "Biroul meu Național",
    "notifications.training_has_been_removed": "Training șters",
    "label.nominated_and_identified_persons": "Persoane nominalizate și identificate care pot vedea date, dar nu pot edita",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "Ați fost deconectat din cauza inactivității",
    "states.award_leader_signoff": "Aprobare de către Lider Award",
    "table.award_signoff_attempts": "Încercări de aprobare finală Award",
    "sidebar.regions": "Regiuni",
    "label.activity_deleted_note": "Această activitate este ștearsă. Poți să o restabilești dacă apeși butonul de mai jos.",
    "table.total": "Total",
    "errors.a_problem_has_occured_during_processing": "",
    "participant.participant_already_has_gold_award": "",
    "pageTitle.mro": "Biroul meu Regional",
    "notifications.authorization_code_has_expired": "Codul de autorizare a expirat",
    "moduleTitle.child_organization_labels": "",
    "aj.aj_events": "Evenimente Aventură",
    "global.loading": "Se încarcă",
    "label.gnipp": "",
    "sidebar.registrations": "Înregistrări",
    "label.any_string": "Orice string",
    "contact.change_contact_status": "Schimbă starea contactului",
    "tabs.registration": "Înregistrare",
    "label.override_payment_note": "Mesaj plată către furnizor",
    "notifications.section_has_been_signed_off": "Secțiunea a fost aprobată",
    "label.payment_date": "Data plății",
    "button.approve": "Aprobă",
    "moduleTitle.loggin_in": "Autentificare",
    "label.website": "Site web",
    "label.role": "Rol",
    "table.assessor_report": "Raport Evaluator",
    "label.ue_fe": "",
    "label.please_comment_on_the_participants_effort": "",
    "label.previously_worked_as_assessor": "Am lucrat ca Evaluator anterior",
    "pageTitle.registrations": "Înregistrări",
    "parentalConsent.this_form_must_be_completed": "Acest formular <strong>trebuie</strong> completat de un părinte/tutore pentru participanții sub <strong> 18 ani </strong>.",
    "button.apply": "",
    "errors.include_at_least_one_number": "Include cel puțin o cifră",
    "label.content_restore": "Sesiunea se împrospătează ...",
    "logs.hour": "oră",
    "parentalConsent.i_have_read_and_understand": "7. Am citit și înțeles diferitele niveluri și cerințe ale programului Award, așa cum sunt evidențiate în Descrierea programului Award (pagina 5 a acestui formular).",
    "notifications.award_was_deleted": "",
    "label.journey_category": "Categorie călătorie",
    "notifications.search_cancelled": "",
    "route.detail": "Detalii",
    "route.user_guide": "Ghid utilizator",
    "moduleTitle.history": "Istorie",
    "table.gop_name": "",
    "pageTitle.tasks_unassigned_participants": "Participanți nealocați",
    "states.inactive": "Inactiv",
    "pageTitle.search_results": "Rezultatele căutării",
    "button.proceed_to_login": "Continuați la Autentificare",
    "pageTitle.assessor_report_reject": "Raport Evaluator Revizuire",
    "notifications.contact_has_been_removed": "Contactul a fost șters",
    "sidebar.operating_authorities": "Autorități Operaționale",
    "label.no_note_from_participant": "",
    "aj.preparation_and_training": "Pregătire și instruire",
    "route.user_guide_web_leader": "Ghid utilizator web - Lider Award",
    "label.position_in_organization": "Poziția în organizație",
    "errors.emails_dont_match": "Adresele de email nu se potrivesc",
    "route.my_participants": "Participanții mei",
    "pageTitle.customisations": "Personalizare",
    "tabs.localization_files": "Localizare fișiere",
    "table.assessor_approval": "Aprobare evaluator",
    "tabs.related_contacts": "Contacte conexe",
    "table.aus": "Unități Award",
    "table.category": "",
    "errors.file_is_too_large": "",
    "label.possible_values": "Valori posibile:",
    "label.if_your_download_doesnt_start": "Dacă descărcare nu începe automat, vă rugăm dați click pe acest",
    "route.independent_award_centres": "Centre Independente Award",
    "pageTitle.user_guide": "Ghiduri utilizator",
    "button.visit": "",
    "label.hours_first_letter": "h",
    "pageTitle.my_organization_detail": "Organizația mea - Detalii",
    "pageTitle.nao_detail": "Birou Național - Detalii",
    "button.change": "Schimbă",
    "award.aj": "Aventură",
    "table.award_state": "Stare program Award",
    "pageTitle.tasks_award_signoff": "Aprobare Program Award",
    "pageTitle.regions": "Regiuni",
    "notifications.award_has_been_signed_off": "Programul Award a fost aprobat",
    "dashboard.award_approved_by": "Programe Award aprobate - după nivel în 2016",
    "tabs.new_template": "Șablon nou",
    "error.parent_email_must_be_filled": "",
    "label.organisation_invoicing_name": "",
    "pageTitle.related_contacts": "Contacte conexe",
    "button.try_again": "Închide avertizarea și încearcă din nou",
    "label.cannot_be_change_to_another": "Nu poate fi schimbat la un alt nivel Award",
    "notifications.lead_coordinator_has_been_set": "",
    "label.training_name": "Nume Training",
    "moduleTitle.new_contact": "Contact nou",
    "translationsManagement.modal.updateTitle": "",
    "moduleTitle.offline_award_units_signoff": "",
    "notifications.award_level_has_been_changed": "Nivelul Award a fost schimbat",
    "label.subject": "Subiect",
    "route.silver_level": "Nivelul de Argint",
    "label.privacy_notice": "",
    "label.switch_organization": "Schimbă Organizația",
    "meta.dofe_name": "The Duke of Edinburgh’s Award",
    "route.profile": "Profil",
    "roles.super_user": "Super-utilizator",
    "dashboard.while_you_were_gone": "Cât ai fost plecat",
    "label.no_note_from_award_leader": "",
    "label.middle_name": "Al doilea prenume",
    "moduleTitle.new_activity": "Activitate nouă",
    "organisation.would_you_like_to_remove": "Doriți să ștergeți această organizație?",
    "label.state_province": "Stat/Provincie/Regiune",
    "moduleTitle.your_home_address": "Adresa de domiciliu",
    "tabs.sign_offs": "Aprobări",
    "moduleTitle.logs": "Note de jurnal",
    "button.view_more": "Vezi mai mult",
    "label.profile": "Profil",
    "label.title": "Titlu",
    "tabs.award_signoff": "Aprobare program Award",
    "label.post_code": "Cod poștal",
    "states.ceremony_certificate": "Ceremonie și Certificat",
    "label.code": "",
    "parentalConsent.i_consent_to_the_provision_of_any": "Sunt de acord cu furnizarea de informații personale pe care le-am oferit (inclusiv datele participantului) Unității Award și Operatorului Award. Sunt de acord ca aceste informații să fie prelucrate conform clauzelor politicii confidențiale ale Operatorului Award (cu amendamente periodice), conform Principiilor Confidențiale Naționale din Actul Protecției Datelor (UK) 1998 (sau politicilor și actelor echivalente, relevante, locale), și oricăror legislații, standarde, ghiduri sau instrucțiuni confidențiale, suspunându-mă lor conform legislației privind confidențialitatea datelor.",
    "label.user_guide_web_participant": "Ghid utilizator web - Participant",
    "label.award_unit_type": "Tipul Unității Award",
    "states.complete": "",
    "table.participant_state": "Starea participantului",
    "pageTitle.my_organization_payment": "Organizația mea - Plată",
    "table.approved": "Aprobat",
    "pageTitle.my_organization_contacts": "Organizația mea - Contacte",
    "warning.award_marked_as_paid_registration": "",
    "states.change_to_state": "Schimbă în <strong>{state}</strong> state?",
    "label.integer": "Număr întreg",
    "notifications.translationUpdateInterrupted": "",
    "notifications.password_has_been_changed": "Parola a fost schimbată",
    "button.invite_assessor": "Invită evaluator",
    "label.other_activity": "Altă activitate",
    "notifications.parental_consent_has_been_sent": "Acordul Părintelui a fost trimis",
    "button.revise": "Revizuiște",
    "errors.end_date_must_be_after_start_date": "Data de final tebuie să fie după data de început",
    "label.award_leader_signoff_date": "",
    "parentalConsent.i_understand_every_participant_must": "8. Înțeleg că fiecare participant trebuie să ia parte la Award prin intermediul unei Unități Award care are dreptul să accepte sau refuze participanții și activitățile propuse a fi efectuate în cadrul programului.",
    "moduleTitle.policies": "",
    "pageTitle.tasks_aj": "Aventură",
    "global.day": "zi",
    "moduleTitle.coordinator": "Coordonator",
    "label.region": "Regiune",
    "button.add_history_record": "Adaugă înregistrare în Istorie",
    "moduleTitle.adventurous_journey_template_settings": "Setări Șabloane Aventură",
    "notifications.personal_details_have_been_updated": "Detaliile personale au fost actalizate",
    "sidebar.ics": "Țări independente (GBT)",
    "table.independent_award_centre": "Centru Independent Award",
    "label.undelivered_mail_reason": "",
    "table.utc_date_time": "",
    "moduleTitle.emails": "",
    "label.backoffice": "",
    "moduleTitle.parent_consent": "Acordul Părintelui / Tutorelui",
    "label.photo_consent_given": "Participantul este de acord să-i folosim poza de profil pentru promovare",
    "moduleTitle.authorising_contact": "Persoana de contact autorizată",
    "label.assessment_with_role": "Evaluare {role}",
    "dashboard.type_of_awards": "Tipul Unității Award",
    "moduleTitle.payment": "Plată",
    "states.in_progress": "În progress",
    "logs.no_logs": "Nicio notă de jurnal",
    "sidebar.my_office": "Biroul meu",
    "label.assessor_report": "Raport Evaluator",
    "notifications.rp_has_been_signed_off": "Proiectul Rezidențial a fost aprobat",
    "tabs.labels": "",
    "sidebar.payments": "Plăți",
    "meta.profile_questions": "Întrebări de profil",
    "label.fax": "Fax",
    "label.email_help_custom_link": "",
    "label.last_name": "Nume de familie",
    "organisation.manage_gop": "",
    "table.parental_consent": "",
    "dashboard.participant_by_level": "Participanți - după Nivel",
    "tabs.award_leaders": "Lideri Award",
    "label.i_confirm_that_ive_witnessed": "",
    "table.lead_coordinator": "",
    "states.deleted": "Șters",
    "label.no_answers": "Niciun răspuns",
    "button.add": "Adaugă",
    "label.exchequer_number": "",
    "label.waiting": "În așteptare",
    "label.email_help_person_full_name": "",
    "tasks.return_registration": "Revizuire înregistrare",
    "notifications.state_aj_preparation_training_has_been_changed": "",
    "label.parent_approval": "Acord părinte",
    "table.assessor_approve": "Aprobare Evaluator\n",
    "errors.some_fields_requires_your_attention": "Unele câmpuri au nevoie de atenția ta",
    "aj.qualifying_journey": "Călătorie finală",
    "route.awards": "Awards",
    "table.registration": "Înscriere",
    "pageTitle.assessors": "Evaluatori",
    "notifications.award_has_been_updated": "Programul Award a fost actulizat",
    "errors.must_be_one_of": "Trebuie să fie unul dintre",
    "pageTitle.logs": "Note de jurnal",
    "notifications.notifications.invitation_has_been_sent": "",
    "route.national_offices": "Birouri Naționale",
    "notifications.training_has_been_updated": "Training actualizat",
    "label.parent_last_name": "Numele de familie al Părintelui / Tutorelui",
    "table.leaders": "Lideri",
    "states.award_level_complete": "Nivel Award finalizat",
    "button.reset": "Resetare",
    "sidebar.my_award_unit": "Unitatea mea Award",
    "pageTitle.all_aj_events": "Toate evenimentele Aventură",
    "label.activity": "Activitate",
    "moduleTitle.are_you_sure": "Sigur?",
    "route.gold_level": "Nivelul de Aur",
    "table.evidence": "Evidență",
    "label.delivery_confirmed": "Livrare Confirmată",
    "parentalConsent.as_the_parent": "În calitate de părinte/tutore, sunt de acord ca pozele să fie folosite de Fundație în scop promoțional.",
    "label.awardMode.offline": "",
    "tasks.approve_registration": "Aprobă înregistrarea",
    "note.change_the_email_will_change": "Notă: Schimbarea adresei de email va schimba și adresa de email a contactului transferat",
    "notifications.participant_has_been_approved": "Participantul a fost aprobat",
    "label.reached_activity_limit": "Limita activităților este atinsă în această secțiune de activitate. Participantul poate avea maxim 3 activități în fiecare secțiune.",
    "label.facebook": "Facebook",
    "notifications.label_has_been_removed": "",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "Pregătirea și instruirea au fost șterse",
    "pageTitle.settings": "Setări",
    "participant.level_registration_date": "Data înscrierii a {value}",
    "notifications.question_has_been_removed": "Întrebarea a fost ștearsă",
    "label.email_help_award_leader_full_name": "",
    "sidebar.leaders": "Lideri",
    "notifications.participants_have_been_transferred": "Participanții au fost transferați",
    "tabs.assessors": "Evaluatori",
    "sidebar.dashboard": "Bord",
    "pageTitle.independent_award_centers": "Centre Independente Award",
    "label.search": "Căutare",
    "moduleTitle.office_labels": "",
    "label.note_from_participant": "Mesaj din partea participantului",
    "errors.required_field": "Câmp obligatoriu",
    "tasks.approve_task": "Aprobă cerință",
    "logs.edit_log": "Editează nota de jurnal",
    "table.state": "Stare",
    "moduleTitle.level_summary": "",
    "moduleTitle.guides": "",
    "modal.close": "Închide",
    "label.parent_first_name": "Prenumele Părintelui / Tutorelui",
    "parentalConsent.i_understand_that_the_participant": "1. Înțeleg că participantul nu poate lua parte la programul Award până ce acest formular nu este completat (alături de acordul părintelui/tutorelui), predat Operatorului Award, împreună cu taxa de înregistrare convenită, și acceptat de Unitatea Award.",
    "tabs.award_units": "Unități Award",
    "table.hours": "Ore",
    "label.type": "Tip",
    "notifications.adventurous_journey_has_been_removed": "Aventura a fost ștearsă",
    "label.aj_is_not_approved_yet": "Secțiunea Aventură nu este aprobată încă",
    "roles.authorizing_contact": "Persoana de contact autorizată",
    "table.date_submitted_to_office_signoff": "Data trimisă către Biroul Award pentru aprobare finală",
    "notifications.section_has_been_returned": "Secțiunea a fost revizuită",
    "table.created_by": "Creat de",
    "route.user_guide_web_participant": "Ghid utilizator web -  Participant",
    "route.templates": "Șabloane",
    "states.awaiting_sign_off": "Aprobare de către Liderul Award",
    "table.phone": "Telefon",
    "label.parental_consent": "Acodul părinților",
    "label.org_contact_will_be_deleted": "",
    "route.bronze_level": "Nivelul de Bronz",
    "label.invoice_currency": "Moneda de facturare",
    "button.new_label": "",
    "error.server_cannot_be_reached_at_the_moment": "",
    "notifications.contact_has_been_created": "Contactul a fost creat",
    "pageTitle.profile_questions": "Întrebări de profil",
    "table.observation_files": "Fișiere de observație",
    "table.participants": "Participanți",
    "tasks.no_evidence": "Nu s-a dat nicio evidență",
    "button.edit": "Confirmă",
    "moduleTitle.leader": "Lider",
    "notifications.new_template_has_been_updated": "A fost actualizat șablon nou",
    "table.name": "Nume",
    "label.no_results": "Nu sunt rezultate",
    "moduleTitle.documents": "Documente",
    "button.invite": "Invită",
    "label.goal": "Scop",
    "pageTitle.nao_award_units": "Birou Național - Unități Award",
    "label.award_delete_participant_id": "",
    "errors.at_least_num_characters": "Cel puțin {length} caractere",
    "label.email_help_note": "",
    "label.person_status.activating": "",
    "moduleTitle.remove_role": "Îndepărtează rol?",
    "label.total": "Total",
    "label.delete_participant_award_info": "",
    "route.leaders": "Lideri",
    "table.start_date": "Data de început",
    "moduleTitle.coordinators": "Coordonatori",
    "button.create": "Creează",
    "tabs.awards": "Programe Award",
    "parentalConsent.form_has_been_sent": "Acordul părintelui a fost trimis",
    "states.journey_approval": "Aprobare călătorie",
    "pageTitle.reports": "Rapoarte",
    "table.journey_type": "Tipul călătoriei",
    "label.yes": "Da",
    "pageTitle.assessor_report": "Raportul Eveluatorului",
    "label.organization": "Organizație",
    "notifications.award_leader_has_been_updated": "Lider Award actualizat",
    "moduleTitle.edit_role": "Editează rol",
    "table.journey_activity": "Activitate călătorie",
    "label.location": "Locație",
    "label.update_translations_error_item": "",
    "pageTitle.adventurous_journeys": "Călătorii Aventură",
    "global.assessor": "Evaluator",
    "moduleTitle.profile_questions": "Întrebări de profil",
    "activity.cannot_edit_activity_if_award_in_state": "Activitatea nu poate fi editată dacă programul este în starea {state}",
    "moduleTitle.assessor_detail": "Detalii Evaluator",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. Înțeleg că, în momentul în care participantul este acceptat în programul Award de către Unitatea Award, acesta va primi un Carnet de Progres sau va primi acces la Online Recod Book (ORB). Participantul va citi cerințele programului din Carnetul de Progres sau de pe ORB înainte de a începe activitățile în Award. Înțeleg că Unitatea Award are dreptul să hotărască dacă cerințele au fost satisfăcute și dacă astfel participantul va fi premiat conform nivelului Bronz, Argint, sau Aur. Înțeleg că Operatorul Award poate asigura participanții, în anumite limite, cu privire la accidente personale și răspundere juridică la acceptarea lui în Award de Unitatea Award, dar răspunderea pentru obținerea și menținerea acoperirii accidentului personal revine participantului și /sau prărintelui/tutorelui.",
    "notifications.award_has_been_returned": "Programul Award a fost revizuit",
    "label.code_of_conduct": "",
    "button.new_contact": "Contact nou",
    "tabs.payments": "Plăți",
    "roles.naa_oa_staff": "Personal ANA AO",
    "label.switch_organisation_hint": "Puteți deschide acest dialog oricând alegând 'Schimbă Organizația' din meniul din colțul dreapta sus",
    "label.expiration_date": "Data expirării",
    "tabs.participants": "Participanți",
    "table.practice": "Călătorie de antrenament",
    "notifications.one_activity_has_to_remain": "Trebuie să rămână neștearsă o activitate în această secțiune",
    "label.qualifications": "Calificări",
    "states.organization_approval": "Aprobare organizație",
    "errors.must_be_an_integer": "Trebuie să fie întreg",
    "participant.send_confirmation_email_again_question": "Trimite emailul de confirmare din nou?",
    "button.dismiss": "Ignoră",
    "table.advice": "",
    "label.years_of_working_experience": "Ani de experiență în muncă",
    "notifications.search_failed": "A apărut o eroare în timpul căutării. Vă rugăm încercați mai târziu.",
    "notifications.changes_have_been_saved": "",
    "moduleTitle.resend_parental_consent_link": "Retrimite link cu acordul părintelui?",
    "label.activity_type": "Tipul activității",
    "label.change_award": "Schimbă nivel Award",
    "label.email": "Email",
    "button.remove": "Înlătură",
    "button.download": "Descărcare",
    "label.vat_treatment": "",
    "pageTitle.aj_template_new": "Șablon Aventură Nouă",
    "table.per_page": "pe pagină",
    "notifications.translations_has_been_updated": "",
    "notification.award_mode_has_been_updated": "",
    "tasks.revise_item": "Revizuiește activitatea",
    "button.resend_parental_consent": "Retrimite acordul părintelui",
    "table.weeks_completed_required": "Săptămâni finalizate / necesare",
    "label.last_modified": "",
    "table.major": "Activitate lungă",
    "label.vat_number": "",
    "errors.passwords_dont_match": "Parolele nu se potrivesc",
    "table.country": "Țara",
    "sidebar.guides_and_policies": "",
    "notifications.question_has_been_updated": "Întrebarea a fost actualizată",
    "table.participant_name": "",
    "label.registration_approval_date": "",
    "notifications.auth_code_is_no_longer_valid": "Codul de autorizare nu mai este valabil",
    "errors.must_be_no_more_than": "Nu trebuie să fie mai mult de {max} caractere",
    "notifications.event_has_been_rejected": "Evenimentul a fost revizuit",
    "tabs.customizations": "Personalizare",
    "label.name_organization": "Nume",
    "button.add_log": "Adaugă notă de jurnal",
    "moduleTitle.invite_assessor": "Invită evaluator",
    "label.resend_confirmation_email": "",
    "text.all_participants_will_be_transfered": "Toți participanții vor fi transferați unui alt Lider Award",
    "label.repeat_email": "Repetă email",
    "errors.email_or_phone_required": "",
    "notifications.role_has_been_updated": "Rolul a fost actualizat",
    "roles.if_staff_stat_user": "",
    "participant.delete_account": "Șterge cont",
    "moduleTitle.would_you_like_to_remove_this_log": "Vrei să ștergi această notă de jurnal?",
    "sidebar.sgops": "",
    "label.prepare_new_email": "",
    "table.journey_category": "Categorie călătorie",
    "sidebar.manual_data_import": "",
    "label.created_after_date": "",
    "route.my_organization": "Organizația mea",
    "button.show_list": "",
    "label.leaders": "Lideri",
    "notifications.log_has_been_modified": "Nota de jurnal a fost modificată",
    "button.upload_file": "Încarcă fișier",
    "moduleTitle.which_section_do_you_want_to": "Ce secțiune doriți să repuneți în modul 'În progres'?",
    "tabs.bronze_level": "Nivelul Bronz",
    "notifications.participants_have_been_saved": "Participanții au fost salvați",
    "pageTitle.aj_template_detail": "Aventură",
    "label.parent_email": "E-mail părinte/tutore",
    "map.appr_location": "Adresa aproximativă",
    "notifications.log_has_been_removed": "Nota de jurnal a fost ștearsă",
    "notifications.label_has_been_assigned": "",
    "pageTitle.tasks_undelivered_emails": "",
    "button.stay": "Rămâi",
    "table.previous_level": "Nivel anterior",
    "label.award_start_date": "Data de începere Award",
    "assessor_report.returned_to_participant": "Înapoiat participantului",
    "pageTitle.tasks_assessors_registration": "Înregistrare Evaluator",
    "aj.cannot_modify_award": "Nu puteți modifica Nivelul Award dacă participantul este alocat unei călătorii.",
    "moduleTitle.lost_internet_connection": "Se pare că ați pierdut conexiunea la internet",
    "states.ceremony": "Ceremonie",
    "participant.reactivate_account": "Reactivează cont",
    "label.birthdate": "Data nașterii",
    "pageTitle.assessment_send_successfully": "Evaluare trimisă cu success",
    "states.assessor_approval": "Aprobare Evaluator",
    "award.change_award_level": "Schimbă nivel Award",
    "label.url_no_longer_valid": "Acest url nu mai este valid",
    "button.update": "Actualizare",
    "label.secondary_email": "E-mail secundar",
    "button.role_edit": "Editează",
    "table.award_leader": "Lider Award",
    "label.level": "Nivel",
    "tasks.evidence": "Evidență",
    "notifications.participant_is_already_in_list": "Participantul este deja în listă",
    "button.clear": "Golește",
    "label.allow_log_after_25_yoa": "",
    "states.setup": "Setare",
    "table.activity": "Activitate",
    "label.copy_to_clipboard": "",
    "route.award_units": "Unități Award",
    "button.upload_photo": "Încarcă poză",
    "table.hours_completed_required": "Ore finalizate / Necesare",
    "table.first_name": "Prenume",
    "notifications.adventurous_journey_has_been_returned": "Aventura a fost revizuită",
    "pageTitle.national_offices": "Birouri Naționale",
    "notifications.you_have_been_logged_in": "Ați fost autentificat",
    "logs.offline": "",
    "moduleTitle.add_role": "Adaugă rol",
    "label.user_app_guide_participant": "Ghid utilizator app - Participant",
    "notifications.file_has_been_removed": "Fișierul a fost șters",
    "label.send_message": "",
    "button.select": "Selectează",
    "label.reason_of_deletion": "Motivul ștergerii",
    "label.user_guide": "Ghid utilizator",
    "pageTitle.nao_participants": "Birou Național - Participanți",
    "tabs.sub_operating_partners": "",
    "table.uploaded_by": "Încărcat de ",
    "tasks.approve_item": "Aprobă activitatea",
    "tasks.restore_participant_registration": "",
    "label.awardMode.hybrid": "",
    "table.first_activity_started": "Prima activitate a început",
    "moduleTitle.dates": "Date",
    "table.no_results": "Nu sunt rezultate",
    "states.registration_approval": "Aprobare înscriere",
    "table.breakdown_of_hours": "Întrerupere ore",
    "pageTitle.tasks_registration": "Înregistrare Participant",
    "button.create_new": "Creează nou",
    "sidebar.todolist": "Lista de priorități",
    "label.active_participants": "Participanți activi",
    "moduleTitle.postalAddress": "",
    "tasks.return_task": "Revizuiește cerință",
    "organisation.change_organisation_state": "Schimbă statutul Organizației",
    "moduleTitle.roles": "",
    "label.no_config_key_available": "",
    "placeholder.selectLanguage": "",
    "states.office_signoff": "Aprobare de către Birou",
    "notifications.translations_has_been_updated.failure": "",
    "logs.minute": "minut",
    "label.last_activity": "Ultima Activitate",
    "sidebar.user_guide": "Ghiduri utilizatori",
    "label.trained_award_leader": "Lider Award format",
    "table.progress": "Progres",
    "table.suboperating_authorities": "Autorități Sub-Operaționale",
    "activity.cannot_edit_activity_offline": "",
    "label.user_does_not_have_permissions": "Utilizatorul <strong>{user}</strong> nu are permisiunea să vadă acest conținut",
    "notifications.assessor_has_been_approved": "Evaluatorul a fost aprobat",
    "route.activity_approval": "Aprobare Activitate",
    "moduleTitle.role": "Rol",
    "button.run": "Execută",
    "label.to": "Către",
    "notifications.file_has_been_updated": "Fișierul a fost actualizat",
    "moduleTitle.edit_coordinator": "",
    "notifications.authorization_code_is_no_longer_valid": "Codul de autorizare nu mai este valid",
    "button.reject": "Revizuiște",
    "label.label.participant_status": "Statut participant",
    "award.gold_level": "Nivelul de Aur",
    "sidebar.variables": "Variabile",
    "parentalConsent.checkbox_copy": "Confirm că sunt părintele/tutorele lui {prenume} {numeDeFamilie}. Sunt de acord ca el/ea să ia parte la programul Award în {numeOrganizație}, sub supravegherea unui Lider Award format. Am citit, înțeles și sunt de acord cu cerințele și condițiile participării în program, așa cum sunt descrise mai sus și pe site-ul Operatorului Award.",
    "button.go_to_dashboard": "Mergi la bord",
    "button.add_option": "Adaugă opțiune",
    "label.is_completed": "Finalizat",
    "pageTitle.award_units": "Unități Award",
    "states.completed": "Finalizat",
    "button.adventurous_journey_template_settings": "Setări Șabloane Aventură",
    "label.system_rights": "Drepturile sistemului",
    "label.assessor_assesstment_award_start_date": "",
    "label.update_translation_question": "",
    "button.login": "Autentificare",
    "label.name_of_the_unit": "Numele unității",
    "button.send": "Trimite",
    "award.ajs": "Călătorii",
    "meta.payments_expired": "Plăți expirate",
    "label.age": "Vârsta",
    "notifications.payment_info_updated": "Informațiile despre plată au fost actualizate",
    "table.is_completed": "Finalizat",
    "table.invited_by": "Invitat de ",
    "route.files": "Fișiere",
    "route.assessors": "Evaluatori",
    "info.aj_supervisor_is_mandatory": "",
    "pageTitle.my_participants": "Participanții mei",
    "label.change_leader_status": "Schimbă statutul Liderului",
    "moduleTitle.parent_consent_form": "Acordul Părintelui / Tutorelui",
    "notifications.authorization_contact_has_been_set": "Persoana de contact autorizată a fost configurată",
    "button.close": "Închide",
    "label.independent_country": "Țară independentă",
    "notifications.aj_preparation_training_has_been_returned": "Pregătirea și Instruirea din secțiunea Aventură au fost revizuite",
    "route.history_log": "Istorie Note de jurnal",
    "participant.account_settings": "Setări cont",
    "label.bulk_action_error_item": "",
    "label.orb_account": "",
    "notifications.file_url_is_not_specified_in_configuration": "URL-ul fișierului nu este specificat în configurare",
    "notifications.award_unit_has_been_removed": "Unitatea/CIA Award a fost șters",
    "table.parent": "Părinte",
    "label.mode_of_transport": "Modalitatea călătoriei",
    "label.parental_consent_email_info": "",
    "label.current_award": "Programul Award actual",
    "table.action": "Acțiune",
    "pageTitle.suboperating_authorities": "Autorități Sub-operaționale",
    "notifications.award_leader_has_been_assigned": "Liderul Award a fost alocat",
    "tabs.sign_offs_locally": "Aprobări locale",
    "Activity log has been restored": "notification.log_has_been_restored",
    "sidebar.naos": "ANA-uri",
    "tabs.aj_templates": "Șabloane Aventură",
    "notifications.logging_out": "Deconectare...",
    "label.update_label": "",
    "button.organisation_settings": "Setări organizație",
    "tabs.independent_award_centers": "Centre Independente Award",
    "label.current": "",
    "table.location": "Locație",
    "button.search": "Caută",
    "notifications.aj_preparation_training_has_been_approved": "Pregătirea și Instruirea din secțiunea Aventură au fost aprobate",
    "route.participants": "Participanți",
    "label.other_location_information": "Alte informații locație",
    "label.number_of_records": "Numărul de înregistrări",
    "translationsManagement.infoLabel": "",
    "parentalConsent.i_consent_to_pay_all": "5. Sunt de acord să plătesc toate taxele și cheltuielile spitalicești, doctorii sau asistentele, în numele participantului, în cazul unui astfel de accident, răni, boală sau pierdere suferite de participant în timpul participării la, sau a transportului pănă la și de la orice activitate legată de Award.",
    "label.nationality": "Naționalitate",
    "states.approval": "Aprobare",
    "notifications.something_went_wrong": "Ceva nu a mers bine",
    "aj.practice": "Călătorie de antrenament",
    "label.addressLine2": "Adresă Rândul 2",
    "label.please_leave_a_note": "Vă rugăm lăsați un mesaj",
    "placeholder.select": "Selectează",
    "label.observations": "Observații",
    "label.aim": "Scop",
    "label.addressLine1": "Adresa Rândul 1",
    "roles.aj_instructor": "Instructor Aventură",
    "meta.payments_waiting": "Plați în așteptare",
    "label.award_to_delete": "",
    "label.category": "",
    "roles.instructor": "Instructor",
    "moduleTitle.remove_customization_and_reset": "Șterge personalizarea și resetează valoarea configurată?",
    "notifications.participant_registration_has_been_restored": "",
    "organisation.change_award_unit_mode": "",
    "table.organization_type": "",
    "notifications.participant_has_been_deleted": "Participantul a fost șters",
    "label.language_settings": "Setări Limbă",
    "notifications.event_has_been_approved": "Evenimentul a fost aprobat",
    "label.password": "Parolă",
    "label.text": "Text",
    "table.observations": "Observații",
    "notifications.participant_has_been_created": "Participantul a fost creat",
    "table.note_for_al": "Mesaj pentru Lider Award",
    "label.payment_confirmed": "Plata confirmată",
    "label.previous_completed_award_level": "Nivel anterior (nu în ORB)",
    "pageTitle.new_aj_event": "Eveniment nou Aventură",
    "label.backend": "",
    "label.relationship_to_participant": "Relația cu participantul",
    "award.physical_recreation": "Ativități Fizice",
    "contact.collect_emails": "",
    "moduleTitle.assessor_report_reject": "Respingerea raportului evaluatorului",
    "label.supervisor_report": "Raport Supraveghetor",
    "table.role": "Rol",
    "route.user_guide_web_nao": "Ghid utilizator web - ANA",
    "label.page_not_found": "404 - Pagina nu a fost găsită",
    "table.labels": "",
    "notifications.file_has_been_uploaded": "Fișierul a fost încărcat",
    "moduleTitle.address": "Adresa",
    "moduleTitle.lead_coordinator": "",
    "pageTitle.login": "Autentificare",
    "label.frontoffice": "",
    "participant.would_you_like_to_remove_registration": "",
    "notifications.rp_has_been_setup": "Proiectul rezidențial a fost setat",
    "moduleTitle.award_unit": "Unitate Award",
    "button.remove_file": "",
    "moduleTitle.billing_address": "Adresa de facturare",
    "pageTitle.my_aj_events": "Evenimentele mele de Aventură",
    "route.tasks": "Cerințe",
    "button.confirm": "Confirmă",
    "label.national_award_authority": "Autoritatea Națională Award",
    "label.independent_award_centre": "Centru Award Independent",
    "award.generate_award_report": "Generează raport",
    "route.my_region_office_customization": "Biroul meu regional - Personalizare",
    "label.email_help_aj_category": "",
    "label.your_report_has_been_rejected": "",
    "notifications.password_change_request_has_been_sent": "Cererea de schimbare parolă a fost trimisă",
    "tabs.detail": "Detalii",
    "participant.change_participant_status": "Schimbați starea participantului",
    "table.key": "",
    "label.find_address": "Găsește adresa",
    "notifications.assessor_has_been_rejected": "Evaluatorul a fost revizuit",
    "label.transfer_participants": "Transfer participanți",
    "button.continue_to_payment_gateway": "Continuă la portalul de plată",
    "notifications.participant_registration_has_been_removed": "",
    "moduleTitle.page_not_found": "404 - Pagina nu a fost găsită",
    "route.adventurous_journeys": "Călătorii de Aventură",
    "states.registration_assessment": "Evaluare înscriere",
    "heading.change_award_unit_mode": "",
    "label.user_guide_web_nao": "Ghid utilizator web - ANA",
    "tabs.silver_level": "Nivelul de Argint",
    "table.paid_by": "Plătit de",
    "label.your_report_has_been_successfully_sent": "Raportul tău a fost trimis cu succes",
    "sidebar.my_organization": "Organizația mea",
    "pageTitle.participants": "Participanți",
    "notifications.preparation_training_has_been_updated": "Pregătirea și Instruirea au fost actualizate",
    "moduleTitle.server_is_unreachable": "",
    "label.last_activity_date": "",
    "award.bronze_level": "Nivelul de Bronz",
    "moduleTitle.award_units": "Unități Award",
    "table.completed": "Finalizat",
    "moduleTitle.revise_message": "Revizuiește mesaj",
    "table.lastUsed": "",
    "award.bronze_to_gold_level": "",
    "button.change_password": "Schimbă parola",
    "label.nao_price": "Prețul pentru ONA",
    "label.payment_state": "Statut plată",
    "label.wwc_expired": "WWC expired",
    "label.award_office_signoff_date": "",
    "label.award_unit": "Unitate Award",
    "award.gold_level_short": "Aur",
    "moduleTitle.other_info": "Alte informații",
    "table.note": "Mesaj",
    "label.search_by_email_first_or_last": "Caută după email prenume sau nume de familie",
    "tabs.history": "Istorie",
    "notifications.label_has_been_created": "",
    "tabs.unassigned_participants": "Participanți nealocați",
    "table.main_award_leader": "Lider Award principal",
    "parentalConsent.i_as_the_parent": "3. Înțeleg că anumite activități sunt considerate cu risc înalt și este posibil ca acestea să nu fie acoperite de aranjamentele de asigurare ale Operatorului Award. Înțeleg că responsabilitatea tuturor riscurilor apărute în urma participării participantului la programul Award sunt responsabilitatea acestuia.",
    "label.state": "Stat",
    "notifications.award_leader_has_been_removed": "Liderul Award a fost șters",
    "tabs.organization_detail": "Detalii organizație",
    "table.operating_authorities": "Autorități operaționale",
    "label.available_labels": "",
    "modal.select": "Selectează",
    "tabs.expired_payments": "Plăți expirate",
    "moduleTitle.note_for_al": "Mesaj pentru Lider",
    "moduleTitle.confirm": "Confirmare",
    "notification.new_activity_added": "A fost adăugată o activitate nouă",
    "notifications.award_leader_has_been_moved": "Liderul Award a fost mutat",
    "label.award_mode": "",
    "label.phone": "Telefon",
    "notifications.organization_has_been_updated": "Organizația a fost actualizată",
    "moduleTitle.assessor": "Evaluator",
    "label.bulk_action_confirmation": "",
    "table.parent_approval": "Acordul părintelui",
    "label.date_of_delivery": "Data livrării",
    "sidebar.assessors": "Evaluatori",
    "label.journey_activity": "Activitate călătorie",
    "award.inactive_award": "Inactivează program Award",
    "label.end_date": "Data finalizării",
    "label.orb_testing": "",
    "label.no_activities": "Nici o activitate",
    "moduleTitle.please_confirm": "Vă rugăm confirmați",
    "button.login_with_another_account": "Autentificare cu alt cont",
    "tasks.reject_registration": "Revizuire înregistrare",
    "label.submitted_after_date": "Trimis după",
    "label.update_translations_successful": "",
    "button.assign_leader": "Alocă Lider",
    "table.already_running": "Deja livrez",
    "label.no": "Nu",
    "label.count_items_selected": "",
    "label.secondary_phone_number": "Număr de telefon secundar",
    "label.my_experience": "Experiența mea",
    "notifications.adventurous_journey_has_been_approved": "Secțiunea Aventură a fost aprobată",
    "pageTitle.mro_detail": "Biroul meu Regional - Detalii",
    "moduleTitle.nao_specific_info": "Informații specifie ANA",
    "label.preparing_document_for_import": "",
    "tasks.observations": "Observații",
    "notifications.confirmation_email_has_been_sent": "Emailul de confirmare a fost trimis",
    "button.restore": "Refacere",
    "label.importing_file": "",
    "label.or_dont_agree": "sau nu sunteți de acord? Puteți",
    "moduleTitle.award_leader": "Lider Award",
    "label.me": "(eu)",
    "tabs.sub_global_operating_partners": "",
    "button.export_table": "Exportă tabel",
    "organisation.move_award_unit": "",
    "label.file_category": "",
    "notifications.connecting_to_server": "Se conectează la server... ",
    "parentalConsent.i_understand_that_a_and_b": "11. Înțeleg că: <br /> a. un participant nu are voie să conducă un vehicul motorizat sau să transporte alți participanți care iau parte în activități legate de Award dacă nu are un permis valabil și adecvat și dacă nu există o asigurare adecvată care să acopere orice persoană rănită ca o consecință a șofatului participantului; și <br /> b. un participant nu trebuie transportat, cu scopul de a lua parte la Award, de niciun individ care nu este implicat sau nu asistă în organizarea Award-ului decât dacă acel individ are un permis de conducere valabil și adecvat și dacă are o asigurarecare acoperă orice persoană rănită ca urmare a șofatului individului. ",
    "table.reason": "",
    "pageTitle.contacts": "Contacte",
    "states.award_leader_approval": "Aprobare Lider Award",
    "meta.payments": "Plăți",
    "label.suboperating_authority": "Autoritate Sub-operațională",
    "route.my_region_office": "Biroul meu regional",
    "states.registration_not_approved": "Înscrierea nu a fost aprobată",
    "label.direct_entrant": "Participant direct",
    "tabs.all_participants": "Toți Participanții",
    "tabs.payment": "Plată",
    "label.email_help_activity_name": "",
    "title.update_report": "",
    "label.repeat_new_password": "Repetă parola nouă",
    "label.other_roles": "",
    "logs.hours": "ore",
    "notifications.spreadsheet_has_been_imported_successfully": "",
    "label.bulk_action_question": "",
    "moduleTitle.personal_details": "Detalii personale",
    "label.bulk_action_emailing": "",
    "route.my_events": "Evenimentele mele",
    "button.delete_award": "",
    "errors.include_both_lower_and_upper_case": "Include atât majuscule, cât și litere mici",
    "tabs.removed_participant_registrations": "",
    "sidebar.mynao": "ANA",
    "tabs.office_details": "Detalii Birou",
    "label.major": "Activitate lungă",
    "tabs.documents": "Documente",
    "label.new_password": "Parolă nouă",
    "sidebar.adventure_journey": "Aventură",
    "pageTitle.customizations": "Personalizare",
    "moduleTitle.assessor_report": "raport {role}",
    "label.registration_date": "Data înregistrării",
    "notifications.training_has_been_added": "Training a fost adăugat",
    "aj.qualifying": "Călătoria finală",
    "moduleTitle.you_have_been_logged_out_session_terminated": "Ați fost deconectat deoarece sesiunea a fost deja terminată",
    "award.service": "Voluntariat",
    "notifications.rp_state_has_been_changed": "Starea Proiectului Rezidențial a fost modificată",
    "label.ctest_access": "",
    "table.created": "Creat",
    "tasks.revise_task": "Revizuiește cerință",
    "button.assign": "Alocă",
    "button.return": "Revizuiște",
    "table.status": "Status",
    "button.restore_activity": "Restabilește Activitatea",
    "tabs.new_aj_event": "Eveniment nou Aventură",
    "roles.if_staff_viewer": "",
    "notifications.new_template_has_been_created": "A fost creat șablon nou",
    "global.something_went_wrong": "Ceva nu a mers bine",
    "table.expire_day": "Ziua expirării",
    "tabs.history_log": "Istorie note de jurnal",
    "label.form_of_payment": "Modalitatea de plată",
    "button.add_training": "Adaugă Training",
    "label.par_reg_cust_note": "",
    "label.my_qualification": "Calificarea mea",
    "button.add_new_profile_question": "Adaugă întrebare de profil nouă",
    "table.operating_authority": "",
    "table.aim": "Scop",
    "table.awards": "Programe Award",
    "participant.deactivate_account": "Dezactivează cont",
    "table.organization_name": "",
    "label.email_help_award_leader_first_name": "",
    "table.date": "Data",
    "tasks.would_you_like_to_delete": "Vrei să ștergi acest participant?",
    "notifications.configuration_value_has_been_updated": "Valoarea de configurare a fost actualizată",
    "ajTemplates.fill_from_template": "Completează din șablon",
    "contact.send_test_email": "Trimtie e-mail de test",
    "moduleTitle.aj_preparation_and_training": "Pregătire și Instruire Aventură",
    "label.ce_be": "",
    "button.notify_participant": "",
    "label.parent_phone": "Telefon părinte/turore",
    "label.nao_regulations": "",
    "award.skills": "Abilități Personale",
    "label.reject_application": "respinge această înregistrare.",
    "leader.delete_account": "Șterge cont",
    "table.assign": "Alocă",
    "roles.aj_supervisor": "Supraveghetor Aventură",
    "label.logout": "Deconectare",
    "moduleTitle.award_leader_edit": "Editează Lider Award",
    "moduleTitle.training": "Training",
    "notifications.coordinator_has_been_removed": "Coordonatorul a fost șters",
    "tabs.operating_partners": "",
    "moduleTitle.main_award_leader": "Lider Award principal / Coordonator",
    "label.bulk_action_successful": "",
    "tasks.clear_email_revision": "",
    "table.preparation": "Pregătire",
    "table.delete": "Șterge",
    "label.safeguarding_policy": "",
    "sidebar.reports": "Rapoarte",
    "pageTitle.sub_global_operating_partners": "",
    "label.is_major_activity_confirmation": "",
    "pageTitle.operating_authorities": "Autorități Operaționale",
    "label.delete_participant_award_modal_question_detail": "",
    "label.confirmed": "Confirmat",
    "notifications.invitation_has_been_sent": "Invitația a fost trimisă",
    "pageTitle.independent_countries": "Țări independente",
    "label.assessors_email": "E-mail-ul Evaluatorului",
    "tasks.approve_assessor_registration": "Aprobă înregistrarea evaluatorului",
    "table.award_duration": "Durata programului Award",
    "notifications.organization_has_been_moved": "",
    "pageTitle.nao_payment": "Birou Național - Plată",
    "participant.history_log": "Istorie note de jurnal",
    "label.rejected_with_note": "",
    "label.already_running": "Deja derulez programul",
    "button.continue": "",
    "award.no_data_to_show": "Nu sunt date",
    "participant.send_email_invitation_again_question": "trimite invitație email din nou?",
    "label.reason_for_changing_assessor": "Motivul schimbării evaluatorului",
    "button.delete": "Șterge",
    "moduleTitle.requirements_and_conditions": "Cerințe și condiții",
    "roles.leader": "Lider",
    "label.if_download_doesnt": "",
    "dashboard.your_todo_list": "Lista ta de priorități",
    "notifications.award_unit_has_been_returned": "Unitatea Award a fost revizuită",
    "moduleTitle.participant_activities": "Activitățile participantului",
    "errors.qualification_or_experience_required": "",
    "label.active_leaders": "Lideri Activi",
    "aj.preparation": "Pregătire",
    "button.change_state": "Schimbă starea",
    "label.current_password": "Parola actuală",
    "pageTitle.global_operating_partners": "",
    "moduleTitle.contact_settings": "Setări contact",
    "button.remove_photo": "Șterge poză",
    "notifications.activity_has_been_setup": "Activitatea a fost setată",
    "errors.must_be_more_than": "Trebuie să fie mai mare de {limit}",
    "table.goal": "Scop",
    "notifications.coordinator_has_been_set": "Coordonatorul a fost setat",
    "label.cc": "Cc",
    "label.duration": "Durata",
    "table.actions": "Acțiuni",
    "participant.send_email_invitation_again": "Trimite invitație email din nou?",
    "moduleTitle.would_you_like_to_remove_participant": "Vreți să ștergeți participantul  #{value}",
    "parentalConsent.i_authorise_employees": "4. Autorizez angajații sau reprezentanții Unității Award și alți indivizi care participă, sunt implicați sau asistă la organizarea programului Award, în caz de accident, rănire, boală sau pierdere suferită de participant în timpul participării sau călătoriei spre și de la activități legate de Award, să obțină orice asistență medicală sau tratament, inclusiv și nelimitat la implicarea doctorilor, asistentelor medicale sau spitalizare.",
    "button.reload_page": "Reîncarcă pagina",
    "moduleTitle.update_translations": "",
    "label.report_description": "",
    "table.email": "Email",
    "label.new_goal": "Scop nou",
    "label.participant_survey_parent": "",
    "errors.invalid_email_address": "Adresă email invalidă",
    "pageTitle.new_contact": "Contact nou",
    "sidebar.gops": "",
    "button.manage_participants": "Administreaza participanți",
    "errors.invalid_phone_format": "Număr de telefon invalid",
    "notifications.login_details_have_been_changed": "Detaliile de autentificare au fost schimbate",
    "moduleTitle.participant_logs": "Notele de jurnal ale participantului",
    "label.save": "Salvează",
    "label.frequently_asked_questions": "Întrebări Frecvente (IF)",
    "label.city": "Oraș",
    "notifications.configuration_value_has_been_reset": "Valoarea de configurare a fost resetată",
    "states.office_sign_off": "Aprobare finală de către Biroul Award",
    "button.save": "Salvează",
    "button.import_data_from_selected_file": "",
    "parentalConsent.i_understand_that_the_participant_cannot": "9. Înțeleg că participantul nu poate începe o anumită secțiune a programului până când nu sunt pe deplin satisfăcut că orice voluntar desemnat de participant, care nu este angajat al Unității Award, are experiența și / sau calificările aecvate pentru a instrui, supraveghea sau evalua acea secșiune a programului, și până când orice voluntar relevant au finalizat și predat Unității Award documentația obligatorie.",
    "pageTitle.apiKeys": "",
    "label.international_region": "regiune Internațională",
    "tabs.levels": "Niveluri",
    "tabs.additional_files": "Fișiere adiționale",
    "label.continuation_level": "Nivel de continuare",
    "table.adventurous_journey_detail": "Detalii Aventură",
    "button.set": "Setare",
    "label.i_certify_that_as_the_assessor": "În calitate de {rol} al acestei activități, confirm că participantul a îndeplinit toate cerințele.",
    "table.coordinator": "Coordonator",
    "participant.send_confirmation_email_again": "Trimite emailul de confirmare din nou?",
    "table.report": "Raport",
    "label.update_translations_results": "",
    "table.observation_note": "Mesaj de observare",
    "label.view_more": "Vezi Mai mult",
    "notifications.payment_link_has_been_reset": "Link-ul pentru plată a fost resetat",
    "table.type": "Tip",
    "moduleTitle.updateConfigurationKey": "Actualizare cheie de configurare",
    "sidebar.independent_award_centers": "Centre Independente Award",
    "table.activity_type": "Tipul activității",
    "label.awardMode.online": "",
    "table.data_state": "",
    "button.generate_report": "Generează raport",
    "moduleTitle.assessed_by_award_leader": "Evaluat de Liderul Award",
    "table.child_protection_number": "",
    "button.bulk_change": "",
    "label.send_welcome_email": "",
    "label.award_state": "Stare program Award",
    "moduleTitle.overview": "Prezentare generală",
    "table.aj_detail": "Detalii Aventură",
    "pageTitle.tasks_activity_approvals": "Aprobare activitate",
    "label.section": "Secțiune",
    "route.history": "Istorie",
    "route.event_participants": "Eveniment participanți",
    "participant.account_detail": "Setări cont",
    "route.dashboard": "Bord",
    "table.payments": "Plăți",
    "pageTitle.profile": "Profil",
    "organisation.remove_organisation": "Șterge organizația",
    "pageTitle.my_organization": "Organizația mea",
    "label.award_leader": "",
    "notifications.assessor_has_been_updated": "Evaluatorul a fost actualizat",
    "label.participant_personal_reflection": "",
    "button.add_key": "",
    "header.appMotto": "DUKE",
    "table.qualifying": "Călătorie finală",
    "button.upload": "Încarcă",
    "button.resend": "Retrimite",
    "label.filename": "",
    "label.change_parental_consent": "",
    "button.cancel": "Anulează",
    "label.aply_to_all_langs": "",
    "route.customization": "Personalizare",
    "errors.minimal_duration_is": "Durata minimă este 30 minute",
    "label.email_help_participant_first_name": "",
    "label.participant_status": "Statut participant",
    "award.bronze_level_short": "Bronz",
    "label.phone_type": "Tipul telefonului",
    "global.night": "noapte",
    "button.adventurous_journey_settings": "Setări Aventură",
    "participant.leader_must_be_selected": "Selectați Lider!",
    "pageTitle.translationsManagement": "",
    "moduleTitle.user_added_preparation_and_training": "Utilizatorul a adăugat Pregătire și Instruire",
    "table.approve": "Aprobă",
    "label.role_in_organisation": "Rol în Organizație",
    "states.finished": "Finalizat",
    "label.created": "Creat",
    "button.back_to_home": "Înapoi Acasă",
    "label.options": "Opțiuni",
    "contact.next_level_invitation": "",
    "moduleTitle.activity_detail": "Detalii activitate",
    "route.section_signoff": "Aprobare Secțiune",
    "moduleTitle.assign_labels_bulk": "",
    "button.contact_settings": "Setări contact",
    "label.transation_id": "ID Tranzacție",
    "notifications.activity_has_been_updated": "Activitatea a fost actualizată",
    "sidebar.awards": "Programe Award",
    "parentalConsent.images_consent": "În calitate de părinte/tutore, sunt de acord ca orice imagine să fie folosită de Fundație în scopuri promoționale.",
    "participant.would_you_like_to_delete": "Ați vrea să ștergeți acest cont?",
    "roles.user": "Utilizator",
    "label.label": "",
    "label.select_sheet": "",
    "global.no_results": "Nu sunt rezultate",
    "moduleTitle.address_line_2": "Adresa - Rândul 2",
    "states.awaiting_office_sign_off": "Aprobare de către Birou Award în așteptare",
    "moduleTitle.export": "Exportă",
    "moduleTitle.address_line_1": "Adresa - Rândul 1",
    "notifications.participant_has_been_assigned": "Participantul a fost alocat",
    "roles.viewer": "Vizualizator",
    "label.participants_total": "Număr total de participanți",
    "errors.auth_code_is_no_longer_valid": "Codul de autorizare nu mai este valid - fie a fost folosit deja, fie a expirat",
    "label.file_is_not_available": "",
    "button.select_template": "Selectează șablon",
    "label.payment": "Plată",
    "award.silver_level_short": "Argint",
    "table.participant_id": "",
    "text.hours_old": "",
    "moduleTitle.your_personal_information": "Informațiile voastre personale",
    "aj.minimum_date_recommendation": "Data minimă recomandată pentru Călătoria de antrenament și {name} este",
    "label.date_of_payment": "Data plății",
    "button.view": "Vizualizează",
    "label.create_new_label": "",
    "title.confirmation": "",
    "button.set_participants": "Setează participanți",
    "roles.assessor": "Evaluator",
    "moduleTitle.coordinator_settings": "",
    "label.parent_relationship": "Relația parentală",
    "table.nao": "ANA",
    "notifications.email_has_been_sent": "E-mail-ul a fost trimis",
    "label.email_help_participant_full_name": "",
    "sidebar.suboperating_authorities": "Autorități Sub-operaționale",
    "route.award": "Award",
    "label.no_roles": "Niciun rol",
    "table.files": "Fișiere",
    "aj.minimum_date_requirements": "Data minimă necesară pentru Călătoria finală și {name} este",
    "pageTitle.labels": "",
    "label.participant_is_semi_offline": "",
    "moduleTitle.other_coordinators": "",
    "button.updateSelectedLanguage": "",
    "tasks.approve_award_registration": "Aprobă înregistrare Award",
    "participant.invite_participant_to_next_level": "",
    "label.twitter": "Twitter",
    "pageTitle.awards": "Programe Award",
    "warning.award_marked_as_paid": "",
    "table.edit": "Revizuire",
    "states.change_to_state_warning_missing_hours_to_complete": "",
    "label.dofe": "International Award",
    "moduleTitle.after_assigning_a_role_to_yourself": "",
    "label.transaction_id": "ID Tranzacție",
    "table.suboperating_authority": "",
    "label.participant_survey": "",
    "label.created_by": "Creat de",
    "button.send_confirmation_email_again_question": "Retrimite email de confirmare",
    "label.email_help_award_leader_email": "",
    "label.name": "Nume",
    "tabs.gold_level": "Nivelul de Aur",
    "pageTitle.award_documents": "Documente Award",
    "label.online_payments": "Plăți online",
    "label.child_protection_number": "",
    "participant.send_password_recovery_email": "Trimiteți email de recuperare a parolei?",
    "notifications.new_log_has_been_added": "O notă nouă de jurnal a fost adăugată",
    "moduleTitle.add_gop_role": "",
    "label.organization_name": "Numele organizației",
    "pageTitle.my_organization_templates": "Organizația mea - Șabloane",
    "pageTitle.award_leaders": "Lideri Award",
    "label.status": "Stare",
    "label.street": "Strada",
    "roles.if_staff_superuser": "Superutilizator personal FI",
    "table.licence_holder": "Deținător Licență",
    "label.created_at": "Creat la",
    "table.section": "Secțiune",
    "table.system_rights": "Drepturi Sistem",
    "label.iac_type": "Tipul CIA",
    "label.other": "Altele",
    "moduleTitle.login": "Autentificare",
    "label.no_data_to_show": "Nu sunt date",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "Nu puteți modifica Nivelul Award dacă participantul este alocat unei călătorii de Aventură.",
    "tabs.waiting_payments": "Așteptarea plății",
    "global.supervisor": "Supraveghetor",
    "notifications.new_role_has_been_added": "A fost adăugat un rol nou",
    "award.silver_level": "Nivelul de Argint",
    "heading.change_awards_mode": "",
    "button.save_changes": "Salvează schimbările",
    "organisation.would_you_like_to_move_award_unit": "",
    "label.fields": "",
    "label.email_help_organization_name": "",
    "pageTitle.mro_related_detail": "Biroul meu Regional - Detalii",
    "table.started_at": "Început la",
    "parentalConsent.i_consent_to_the_award_unit": "2. Sunt de acord cu Unitatea Award și orice alt individ, incluzând voluntari* implicați în sau care asistă în organizarea programului Award, cu șoferii angajați care transportă participantul cu scopul participării acestuia în activități legate de Award, după caz. Înțeleg că Unitatea Award mă va anunța înainte de data și locul unei astfel de călătorii.",
    "logs.minutes": "minute",
    "label.total_participants": "Numărul total de participanți",
    "moduleTitle.contact_info": "Informații contact",
    "table.payment_link": "Link-ul plății",
    "errors.please_contact_your_local_award_staff": "Vă rugăm contactați personalul Award local"
}